import { ModuleConfig, ModuleMapConfig } from '@schamburg-web/interfaces';

export const trafficIcon = '/mapicons/traffic.svg';

// Configuration for the Google Traffic module
// This module does not have a display or API configuration as it is purely for map display

const mapModuleConfig: ModuleMapConfig = {
  layerIcon: trafficIcon,
  showOnMap: true,
  defaultEnabled: true,
};

const moduleConfig: ModuleConfig = {
  moduleLabel: 'Google Traffic',
  name: 'traffic',
  mapConfig: mapModuleConfig,
};

export default moduleConfig;
